var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "m-configs" } },
    [
      _vm.loading
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm.message
        ? _c(
            "v-alert",
            {
              staticStyle: {
                "margin-top": "50px",
                "margin-left": "50%",
                left: "-10%",
              },
              attrs: { type: "error", width: "20%" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-card-actions",
                { staticStyle: { height: "70px!important" } },
                [
                  _c(
                    "v-tabs",
                    {
                      staticClass: "no-transition",
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(
                        "v-tab",
                        { attrs: { disabled: !_vm.ifCanViewMyConfigs() } },
                        [
                          _vm._v("My Configs "),
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { size: "20" },
                            },
                            [_vm._v("mdi-strategy")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab",
                        {
                          attrs: {
                            disabled: !_vm.ifCanViewPreReleaseConfigs(),
                          },
                        },
                        [
                          _vm._v("Pre Release "),
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { size: "20" },
                            },
                            [_vm._v("mdi-shield-alert-outline")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab",
                        { attrs: { disabled: !_vm.ifCanViewReleaseConfigs() } },
                        [
                          _vm._v("Release "),
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { size: "20" },
                            },
                            [_vm._v("mdi-shield-check-outline")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab",
                        { attrs: { disabled: !_vm.ifCanViewMasterConfigs() } },
                        [
                          _vm._v("Master "),
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { size: "22" },
                            },
                            [_vm._v("mdi-crown-outline")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab",
                        { attrs: { disabled: !_vm.ifCanViewMergeHistory() } },
                        [
                          _vm._v("Merge History "),
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { size: "22" },
                            },
                            [_vm._v("mdi-history")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab",
                        [
                          _vm._v("Shared Configs "),
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { size: "20" },
                            },
                            [_vm._v("mdi-share-variant-outline")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                {
                  staticClass: "ma-0 pa-0 mx-2",
                  staticStyle: { "border-bottom": "green solid 0px" },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-0 scroll",
                      attrs: {
                        width: "100%",
                        elevation: "0",
                        height: _vm.winsize.height - 145,
                      },
                    },
                    [
                      _c(
                        "v-tabs-items",
                        {
                          staticClass: "mt-0",
                          model: {
                            value: _vm.tab,
                            callback: function ($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab",
                          },
                        },
                        [
                          _c(
                            "v-tab-item",
                            {
                              attrs: {
                                transition: "fade-transition",
                                "reverse-transition": "fade-transition",
                              },
                            },
                            [_c("c-l")],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            {
                              attrs: {
                                transition: "fade-transition",
                                "reverse-transition": "fade-transition",
                              },
                            },
                            [_c("c-pre-release")],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            {
                              attrs: {
                                transition: "fade-transition",
                                "reverse-transition": "fade-transition",
                              },
                            },
                            [_c("c-release")],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            {
                              attrs: {
                                transition: "fade-transition",
                                "reverse-transition": "fade-transition",
                              },
                            },
                            [_c("c-master")],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            {
                              attrs: {
                                transition: "fade-transition",
                                "reverse-transition": "fade-transition",
                              },
                            },
                            [_c("merge-history")],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            {
                              attrs: {
                                transition: "fade-transition",
                                "reverse-transition": "fade-transition",
                              },
                            },
                            [_c("c-shared-configs")],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            {
                              attrs: {
                                transition: "fade-transition",
                                "reverse-transition": "fade-transition",
                              },
                            },
                            [_c("c-branch")],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }